import classnames from "classnames";
import {
  StyledTabButton,
  StyledTabsContainer,
  StyledTabText,
} from "components/apiDocs/BrowseAllPage/style";
import { ApiData } from "models/apiDocumentation/apiDocumentationModels";
import React from "react";

interface Props {
  tabList: string[];
  selectedTab: string | null;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
  apiData: ApiData;
}

const HorizontalSelectionBar: React.FC<Props> = ({
  tabList,
  selectedTab,
  setSelectedTab,
  apiData,
}) => {
  const listOfTagLetters = apiData.tags.map((tag) => tag.name[0]);
  const listOfUniqueTagLetters = [...new Set(listOfTagLetters)];

  return (
    <StyledTabsContainer>
      {tabList.map((tabText, index) => (
        <StyledTabButton
          key={index}
          data-test-id="letter-button"
          onClick={(): void => setSelectedTab(tabText)}
          className={classnames({ active: selectedTab === tabText })}
          disabled={
            !(tabText === "All" || listOfUniqueTagLetters.includes(tabText))
          }
        >
          <StyledTabText>{tabText}</StyledTabText>
        </StyledTabButton>
      ))}
    </StyledTabsContainer>
  );
};

export default HorizontalSelectionBar;
